import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import app from './modules/app'
import report from './modules/report'
export default new Vuex.Store({
  modules: {
    app,
    report
  }
})
